<script lang="ts">
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {allApps, updateApp, createApp, deleteApp} from 'src/components/cabinet/#services/appsGatekeeper'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import IconifyIcon from '@iconify/svelte'
    import saveIcon from '@iconify/icons-fa-solid/save'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'
    import {getAllSettingsOption} from 'src/components/cabinet/#services/settingsOption'

    allApps.reset()
    allApps.send()

    let selectedAppId
    let deleteOptionModal = false
    let name
    let appId
    let isAvailable = false

    let apps
    $: if (!apps && $allApps.hasValue) {
        apps = $allApps.value?.apps && JSON.parse(JSON.stringify($allApps.value.apps))
    }

    function changeHandler(e, appId, name) {
        updateApp.request({ data: { appId, name, isAvailable: e.target.checked } })
    }

    async function save(appId, name, isAvailable) {
        try {
            await updateApp.request({ data: { appId, name, isAvailable } })

            showAlert.set({
                status: 'success',
                text: name+' successfully updated'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            apps = undefined
            allApps.reset()
            allApps.send()
        }
    }

    async function create() {
        try {
            await createApp.request({ data: { appId, name, isAvailable } })

            showAlert.set({
                status: 'success',
                text: name+' successfully added'
            })

            name = ''
            appId = ''
            isAvailable = false
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            apps = undefined
            allApps.reset()
            allApps.send()
        }
    }

    async function deleteHandler() {
        try {
            await deleteApp.request({data: { appId: selectedAppId } })

            deleteOptionModal = false
            selectedAppId = ''

            showAlert.set({
                status: 'success',
                text: 'App successfully deleted'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            apps = undefined
            allApps.reset()
            allApps.send()
        }
    }
</script>

<div class="settings-list">
    {#if !apps && $allApps.loading}
        <tr>
            <td class="text-center" colSpan="3">Loading...</td>
        </tr>
    {:else if !apps && $allApps.error}
        <tr>
            <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
        </tr>
    {:else if apps}
        {#each apps as {appId, name, isAvailable}, i}
            <div class="form-group">
                <div class="input-group mb-3">
                    <span class="input-group-text checkbox-wrapper">
                        <input type="checkbox" class="form-check" checked={isAvailable} on:change={(e) => changeHandler(e, appId, name)}>
                    </span>
                    <input type="number" class="form-control" value={appId} readonly>
                    <input type="text" class="form-control" placeholder="App name" bind:value={name}>
                    <button class="btn btn-primary" on:click={() => save(appId, name, isAvailable)}>
                        <IconifyIcon icon={saveIcon}/>
                    </button>
                    <button class="btn btn-danger" on:click={() => { deleteOptionModal = true; selectedAppId = appId }}>
                        <IconifyIcon icon={deleteIcon}/>
                    </button>
                </div>
            </div>
            <hr>
        {/each}
        <div class="form-group">
            <div class="input-group mb-3">
                <span class="input-group-text checkbox-wrapper">
                    <input type="checkbox" class="form-check" bind:checked={isAvailable}>
                </span>
                <input type="number" class="form-control" placeholder="App ID" bind:value={appId}>
                <input type="text" class="form-control" placeholder="App name" bind:value={name}>
                <button class="btn btn-success" on:click={create}>Add app</button>
            </div>
        </div>
    {/if}
    <Modal bind:visible={deleteOptionModal}>
        <svelte:fragment slot="content">
            <div class="modal-custom__title">Delete app</div>
            <div class="modal-custom__text">Are you sure you want to delete the app?</div>
            <div class="modal-custom__footer">
                <button class="btn btn-cancel" on:click={() => { deleteOptionModal = false }}>Cancel</button>
                <button class="btn btn-primary btn-danger" on:click={deleteHandler}>Confirm</button>
            </div>
        </svelte:fragment>
    </Modal>
</div>

<style>
    .settings-list {
        max-width: 700px;
    }

    .checkbox-wrapper input {
        margin: 0 auto;
        width: 20px;
        cursor: pointer;
    }

    .settings-list .btn-danger {
        padding: 10px 15px;
    }
</style>
